module.exports = __webpack_public_path__ + "static/media/bng.24d92c74.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/client_logo/bng.png
// module id = 27
// module chunks = 0